<template>
  <transition
    :css="false"
    mode="in-out"
    @appear="enterCookie"
    @leave="leaveCookie"
  >
    <div
      v-if="show"
      class="c-template c-template--cookie"
      :data-theme="theme"
    >
      <slot
        v-for="slot in slots"
        :name="slot"
      />
    </div>
  </transition>
</template>

<script>
import anime from 'animejs';

export default {
  name: 'CookieTemplate',

  props: {
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
    slots: {
      type: Array,
      required: false,
      default() {
        return ['content', 'button'];
      },
    },
  },

  data() {
    return {
      show: true,
    };
  },

  methods: {
    enterCookie(el, done) {
      anime({
        targets: el,
        translateY: [-100, '-50%'],
        opacity: [0, 1],
        duration: 1000,
        delay: 500,
        easing: 'easeOutCubic',
        complete: () => {
          done();
        },
      });
    },
    leaveCookie(el, done) {
      anime({
        targets: el,
        translateY: ['-50%', -100],
        opacity: [1, 0],
        duration: 1000,
        easing: 'easeOutCubic',
        complete: () => {
          done();
        },
      });
    },
  },

  created() {
    if (localStorage.getItem('cookie:accepted')) {
      this.show = false;
    }
    this.$on('cookie-accepted', () => { this.show = false; });
  },
};
</script>

<style lang="scss" scoped>
.c-template.c-template--cookie {
  box-sizing: border-box;
  position: fixed;
  width: 95%;
  left: 2.5%;

  z-index: 1000;

  background-color: $color-white;

  @include mq($from: ipadP) {
    width: 550px;
    left: 50%;
    margin-left: -275px;
  }

  @include mq($from: d) {
    width: 40vw;
    left: 50%;
    margin-left: -20vw;
  }

  &[data-theme="default"] {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    text-align: left;
    font-size: 0.8rem;
    color: #4e4e4e;
    top: 15vw;
    border-radius: 5px;
    padding: 15px 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @include mq(mobileL) {
      top: 9.2vw;
    }

    @include mq(ds) {
      top: 5.2vw;
    }
  }
}
</style>
